import axios from "axios";
import * as XLSX from 'xlsx';


class CandidatesService {

  
    getCandidates = async (token, filterAction, filterTestId, offset) => {
        const ret= await axios.get(process.env.REACT_APP_SKILLMETER_API + "/candidates/" + filterAction + "/" + offset + (filterTestId == null ? "" : "?testId=" + filterTestId), { headers: {"Authorization" : `Bearer ${token}`, "Content-type": "multipart/form-data"} });
        return ret.data;
      }

    searchCandidates = async (token, searchText) => {
      const ret= await axios.get(process.env.REACT_APP_SKILLMETER_API + "/candidates/search?query=" + searchText, { headers: {"Authorization" : `Bearer ${token}`, "Content-type": "multipart/form-data"} });
      return ret.data;
    }
      
    getTestsCountByUser = async (token) => {
      const ret= await axios.get(process.env.REACT_APP_SKILLMETER_API + "/candidates/testscountbyuser/", { headers: {"Authorization" : `Bearer ${token}`} });
      return ret.data;
    }
  
    getCandidatesCountByUser = async (token) => {
      const ret= await axios.get(process.env.REACT_APP_SKILLMETER_API + "/candidates/countbyuser/", { headers: {"Authorization" : `Bearer ${token}`} });
      return ret.data;
    }

    getCandidatesCountByCompany = async (token) => {
      const ret= await axios.get(process.env.REACT_APP_SKILLMETER_API + "/candidates/countbycompany/", { headers: {"Authorization" : `Bearer ${token}`} });
      return ret.data;
    }

    addCandidate = async (token, firstName, lastName, email, tests, scheduledDate, multipleSessions, allowResume) => {
      let fd = new FormData();
      fd.append('firstName', firstName);
      fd.append('lastName', lastName);
      fd.append('email', email);
      fd.append('tests', JSON.stringify(tests));
      if (scheduledDate) fd.append('scheduleDate', scheduledDate)
      fd.append('multipleSessions', multipleSessions ? 1 : 0)
      fd.append('allowResume', allowResume ? 1 : 0);
  
      const ret = await axios.post(process.env.REACT_APP_SKILLMETER_API + "/candidates" , fd, { headers: {"Content-Type": "multipart/form-data", "Authorization" : `Bearer ${token}`} });
      return ret;
    }  
  
    deleteCandidate = async(token, candidateId) => {

      const res = await axios.delete(process.env.REACT_APP_SKILLMETER_API + "/candidates/" + candidateId, { headers: {"Authorization" : `Bearer ${token}`, "Content-type": "multipart/form-data"}});
      return res.data;
    }  

    getCandidateAnswers = async (token, candidateId) => {
      const ret= await axios.get(process.env.REACT_APP_SKILLMETER_API + "/candidates/" + candidateId + '/answers', { headers: {"Authorization" : `Bearer ${token}`, "Content-type": "multipart/form-data"} });
      return ret.data;
    }

    getCandidateAnswersPublic = async (publicToken) => {
      const ret= await axios.get(process.env.REACT_APP_SKILLMETER_API + "/candidates/public/answers", { headers: {"Authorization" : `Bearer ${publicToken}`, "Content-type": "multipart/form-data"} });
      return ret.data;
    }

    getCandidate = async (token, candidateId) => {
      const ret= await axios.get(process.env.REACT_APP_SKILLMETER_API + "/candidates/" + candidateId, { headers: {"Authorization" : `Bearer ${token}`, "Content-type": "multipart/form-data"} });
      return ret.data;
    }

    getCandidatePublic = async (publicToken) => {
      const ret= await axios.get(process.env.REACT_APP_SKILLMETER_API + "/candidates/public", { headers: {"Authorization" : `Bearer ${publicToken}`, "Content-type": "multipart/form-data"} });
      return ret.data;
    }

    getTestsDetails = async (token, candidateId) => {
      const ret= await axios.get(process.env.REACT_APP_SKILLMETER_API + "/candidates/" + candidateId + '/tests', { headers: {"Authorization" : `Bearer ${token}`, "Content-type": "multipart/form-data"} });
      return ret.data;
    }

    getTestsDetailsPublic = async (publicToken) => {
      const ret= await axios.get(process.env.REACT_APP_SKILLMETER_API + "/candidates/public/tests", { headers: {"Authorization" : `Bearer ${publicToken}`, "Content-type": "multipart/form-data"} });
      return ret.data;
    }

    markSeenResult = async (token, candidateId) => {
      let fd = new FormData();
      const ret = await axios.patch(process.env.REACT_APP_SKILLMETER_API + "/candidates/" + candidateId + '/seen' , fd, { headers: {"Content-Type": "multipart/form-data", "Authorization" : `Bearer ${token}`} });
      return ret;
    }      

    setAllowResume = async (token, candidateId) => {
      let fd = new FormData();
      const ret = await axios.patch(process.env.REACT_APP_SKILLMETER_API + "/candidates/" + candidateId + '/allowresume' , fd, { headers: {"Content-Type": "multipart/form-data", "Authorization" : `Bearer ${token}`} });
      return ret;
    }      

    saveResponse = async (token, response) => {

      let fd = new FormData();
      fd.append('response', JSON.stringify(response));
  
      return axios.post(process.env.REACT_APP_SKILLMETER_API + "/candidates/" + response.CandidateId + '/answers' , fd,  { headers: {"Authorization" : `Bearer ${token}`, "Content-type": "multipart/form-data"} })
        .then ( (res) => {
            return res.data;
        });
    }  

    updateResult = async (token, candidateId, result) => {
      let fd = new FormData();
      fd.append('status', result);
  
      return axios.post(process.env.REACT_APP_SKILLMETER_API + "/candidates/" + candidateId + '/result' , fd,  { headers: {"Authorization" : `Bearer ${token}`, "Content-type": "multipart/form-data"} })
        .then ( (res) => {
            return res.data;
        });

    }

    getGlobalResult = async (token, testId, score) => {
      const ret= await axios.get(process.env.REACT_APP_SKILLMETER_API + "/candidates/globalresult?testId=" + testId + "&score=" + score, { headers: {"Authorization" : `Bearer ${token}`, "Content-type": "multipart/form-data"} });
      return ret.data;
    }

    exportCandidates = async (token, testId = null, startDate = null, endDate = null) => {
      try {
        // Build query parameters
        const params = new URLSearchParams();
        if (testId) params.append('testId', testId);
        if (startDate) params.append('startDate', startDate);
        if (endDate) params.append('endDate', endDate);
        
        const queryString = params.toString();
        const url = process.env.REACT_APP_SKILLMETER_API + "/candidates/export" + (queryString ? "?" + queryString : "");
        
        const ret = await axios.get(url, { 
          headers: {"Authorization" : `Bearer ${token}`, "Content-type": "multipart/form-data"} 
        });
        
        const candidates = ret.data;
        
        if (!candidates || candidates.length === 0) {
          return { success: false, message: 'No candidates found to export.' };
        }

        // Transform data for Excel export
        const exportData = candidates.map(candidate => ({
          'Candidate ID': candidate.CandidateId,
          'First Name': candidate.First_Name,
          'Last Name': candidate.Last_Name,
          'Email': candidate.Email,
          'Test Name': candidate.TestName,
          'Pin Code': candidate.PinCode,
          'Test Date': candidate.TestDate ? new Date(candidate.TestDate).toLocaleDateString() : 'Not taken',
          'Result': candidate.Passed === true ? 'Passed' : candidate.Passed === false ? 'Failed' : 'Not graded',
          'Score': candidate.TestResult,
          'Results Link': candidate.ResultsLink || ''
        }));

        // Create workbook and worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(exportData);
        
        // Set column widths
        const colWidths = [
          { wch: 12 }, // Candidate ID
          { wch: 15 }, // First Name
          { wch: 15 }, // Last Name
          { wch: 25 }, // Email
          { wch: 20 }, // Test Name
          { wch: 12 }, // Pin Code
          { wch: 15 }, // Test Date
          { wch: 12 }, // Result
          { wch: 12 }, // Score
          { wch: 50 }  // Results Link
        ];
        ws['!cols'] = colWidths;

        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Candidates');

        // Generate filename with timestamp
        const timestamp = new Date().toISOString().split('T')[0];
        const testName = testId ? candidates[0].TestName.replace(/[^a-zA-Z0-9]/g, '_') : 'All_Tests';
        const filename = `candidates_export_${testName}_${timestamp}.xlsx`;

        // Write and download file
        XLSX.writeFile(wb, filename);
        
        return { success: true, filename };
      } catch (error) {
        console.error('Export failed:', error);
        return { success: false, message: 'Export failed. Please try again.', error };
      }
    }

}

export default new CandidatesService();
